var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2107_6657)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8244 0.704305C25.4917 -2.22522 36.4552 4.26445 39.3133 15.1951C42.1714 26.1291 35.84 37.3667 25.1759 40.2963C14.5086 43.2258 3.54507 36.7361 0.687 25.8055C-2.17107 14.8715 4.15705 3.63383 14.8244 0.704305Z",
    fill: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.636 9.2959C15.0358 9.2959 16.1686 10.9342 16.1686 12.9561C16.1686 14.9781 15.0358 16.6164 13.636 16.6164C12.2363 16.6164 11.1035 14.9781 11.1035 12.9561C11.1035 10.9342 12.2363 9.2959 13.636 9.2959ZM9.29358 22.3953C14.7233 22.2218 25.8984 22.4921 30.7063 22.382C30.7063 35.6516 9.29358 36.9195 9.29358 22.3953ZM26.3639 9.2959C27.7636 9.2959 28.8964 10.9342 28.8964 12.9561C28.8964 14.9781 27.7636 16.6164 26.3639 16.6164C24.9642 16.6164 23.8313 14.9781 23.8313 12.9561C23.8313 10.9342 24.9642 9.2959 26.3639 9.2959Z",
    fill: "#141518"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.29358 22.3954C14.7233 21.8883 25.8984 22.1719 30.7063 22.3821C30.7682 27.1034 9.35868 27.0433 9.29358 22.3954Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5651 30.3463C16.1816 33.5527 22.9296 33.6795 26.9856 30.3463C24.7786 27.7738 22.3698 27.6937 19.6972 29.719C16.9433 27.4601 15.0976 27.3967 12.5651 30.3463Z",
    fill: "#898989"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2107_6657"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 41,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.be34636f798dca3cad550b010190b896.svg";
export { ForwardRef as ReactComponent };